import { ThemedText, ThemedView } from "@app/theme"
import AccordionListItem from "./AccordionAnimated"
import { formatIndianCurrency } from "@app/utils/utility"
import { REPAYMENT_COLLECTION_TYPE, roundToTwoDecimalPlaces } from "@app/utils";
import { LENDER_ID } from "@app/types/regix";
import DashedLine from "@app/sharedComponents/DashedLine/DashedLine";
import { Image } from "react-native";


const checkRoundindAmount = (num:any) => {
    if(num > 0 && num < 1)
     return roundToTwoDecimalPlaces(1-num);
    else return 0;
}

const ForeClosureData = ({foreClosureData,lenderId,paymentType,selectedAmount}:any) =>{
        const {outstandingCharges,totalNotionalChargesAndDematBounce,advanceInterest,penalInterestAccruedNotDue,outstandingInterest,interestAccruedNotDue,nextDayInterestChargeDue,penalInterest,outstandingPrincipal} = foreClosureData
        // Advance interest need to make color green
        const totalOutstandingCharges = (outstandingCharges || 0) + (penalInterest || 0) + 
        (paymentType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE 
            ? (penalInterestAccruedNotDue || 0) + (totalNotionalChargesAndDematBounce || 0) 
            : 0);
        const totalOutstandingInterest = (outstandingInterest || 0 ) + 
        (paymentType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE 
            ? (interestAccruedNotDue|| 0) + (nextDayInterestChargeDue || 0)
            : 0);

        const determineForclosureState = () =>{
            const headingmessage ={
                "isForeclosureWithPositiveAmount" :{
                    title:"You have outstanding dues",
                    message:"Please clear your dues to proceed",
                },
                "isForeclosureWithNegativeAmount":{
                    title:"You have excess amount",
                    message:"Place refund request to proceed",
                },
                "isPrincipalRepaymentWithPositiveAmount":{
                    title:"You have no dues",
                    message:"Currently, there are no dues on your loan account.",
                },
                "isPrincipalRepaymentWithNegativeAmount":{
                    title:"You have no dues",
                    message:"Place withdrawal request to get your excess amount",
                },
                "netPayableZero":{
                    title:"You have no dues",
                    message:"Currently, there are no dues on your loan account.",
                },
            }
            let type = null
            if(paymentType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE && selectedAmount > 0){
                type = "isForeclosureWithPositiveAmount"
            } else if(paymentType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE && selectedAmount < 0){
                type = "isForeclosureWithNegativeAmount"
            } else if(paymentType === REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT && selectedAmount > 0){
                type = "isPrincipalRepaymentWithPositiveAmount"
            } else if(paymentType === REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT && selectedAmount < 0){
                type = "isPrincipalRepaymentWithNegativeAmount"
            } else {
                type="netPayableZero"
            }
            return {displayMessage :headingmessage[type], type}
        }
    
        const {displayMessage,type} = determineForclosureState()
        return(
            <>
             {type!=="isPrincipalRepaymentWithPositiveAmount" &&
            <ThemedView backgroundColor="bg-surface-primary" mt="lg" mx="lg" p="md" borderWidth={1} borderColor="border-primary" borderRadius="sm" flexDirection="row" alignItems="center">
                <Image source={{uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/outstanding_icon.png'}} style={{width: 46, height: 46}} />
                <ThemedView ml="md">
                    <ThemedText variant="b3s" color="text-primary">{displayMessage['title']}</ThemedText>
                    <ThemedText variant="b4r" color="text-secondary">{displayMessage['message']}</ThemedText>
                </ThemedView>
            </ThemedView>}
            <ThemedView mx="lg" my="lg" borderWidth={1} borderColor="border-primary" borderRadius="sm" pt="lg">
                <ThemedView px="md" flexDirection="row" alignItems="center" justifyContent="space-between">
                    <ThemedText variant="b3s" color="text-primary">Total amount</ThemedText>
                    <ThemedView flexDirection="row" alignItems="center">
                        <ThemedText variant="l2"  color={selectedAmount >=0 ? "text-primary" : 'text-emphasis-secondary'}>{selectedAmount >= 0 ? '₹' : '-₹'}</ThemedText>
                        <ThemedText variant="h2s" color={selectedAmount >=0 ? "text-primary" : 'text-emphasis-secondary'}>{formatIndianCurrency(Math.abs(selectedAmount))}</ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView mt="lg" px="md">
                    <DashedLine />
                </ThemedView>
                <ThemedView  backgroundColor="bg-surface-primary" borderBottomLeftRadius="sm" borderBottomRightRadius="sm">
                <AccordionListItem
                    title={'Charges due'}
                    subTitle={`${totalOutstandingCharges < 0 ? '-':''}₹${formatIndianCurrency(Math.abs(totalOutstandingCharges))}`}
                    subTitleColor={totalOutstandingCharges < 0 ? "text-emphasis-secondary" : "text-primary"}
                >
                    <ThemedView py="lg">
                        <ThemedView flexDirection="row" justifyContent="space-between" px="lg">
                            <ThemedText variant="b4r" color="text-primary">
                                Outstanding charges
                            </ThemedText>
                            <ThemedText 
                                variant="b4r" 
                                color={outstandingCharges < 0 ? "text-emphasis-secondary" : "text-primary"}
                            >
                                {outstandingCharges<0 && '-'}₹{formatIndianCurrency(Math.abs(outstandingCharges) || 0)}
                            </ThemedText>
                        </ThemedView>
                        {paymentType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE && (
                        <>
                        <ThemedView flexDirection="row" justifyContent="space-between" pt="sm" px="lg">
                            <ThemedText variant="b4r" color="text-primary">
                                Total Demat and bounce charged
                            </ThemedText>
                            <ThemedText 
                                variant="b4r"
                                color={totalNotionalChargesAndDematBounce < 0 ? "text-emphasis-secondary" : "text-primary"}>
                                {totalNotionalChargesAndDematBounce<0 && '-'}₹{formatIndianCurrency(Math.abs(totalNotionalChargesAndDematBounce) || 0)}
                            </ThemedText>
                        </ThemedView>
                        <ThemedView flexDirection="row" justifyContent="space-between" pt="sm" px="lg">
                            <ThemedText variant="b4r" color="text-primary">
                                Penal charges accrued not due
                            </ThemedText>
                            <ThemedText 
                                variant="b4r"
                                color={penalInterestAccruedNotDue < 0 ? "text-emphasis-secondary" : "text-primary"}
                            >
                                {penalInterestAccruedNotDue<0 && '-'}₹{formatIndianCurrency(Math.abs(penalInterestAccruedNotDue) || 0)}
                            </ThemedText>
                        </ThemedView>
                        </>
                        )}
                        {lenderId?.toLowerCase() === LENDER_ID.DSP && penalInterest > 0 && (
                            <ThemedView flexDirection="row" justifyContent="space-between" pt="sm" px="lg">
                                <ThemedText variant="b4r" color="text-primary">
                                    Penal charges
                                </ThemedText>
                                <ThemedText 
                                    variant="b4r"
                                    color={penalInterest < 0 ? "text-emphasis-secondary" : "text-primary"}
                                >
                                   {penalInterest<0 && '-'}₹{formatIndianCurrency(Math.abs(penalInterest) || 0)}
                                </ThemedText>
                            </ThemedView>
                        )}
                    </ThemedView>
                </AccordionListItem>
                <AccordionListItem
                    title={'Interest due'}
                    subTitle={`${totalOutstandingInterest < 0 ? '-':''}₹${formatIndianCurrency(Math.abs(totalOutstandingInterest))}`}
                    subTitleColor={totalOutstandingInterest < 0 ? "text-emphasis-secondary" : "text-primary"}
                >
                    <ThemedView py="lg">
                        <ThemedView flexDirection="row" justifyContent="space-between" px="lg">
                            <ThemedText variant="b4r" color="text-primary">
                                Outstanding Interest
                            </ThemedText>
                            <ThemedText 
                                variant="b4r"
                                color={outstandingInterest < 0 ? "text-emphasis-secondary" : "text-primary"}
                            >
                               {outstandingInterest<0 && '-'}₹{formatIndianCurrency(Math.abs(outstandingInterest) || 0)}
                            </ThemedText>
                        </ThemedView>
                        {paymentType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE && (
                            <ThemedView flexDirection="row" justifyContent="space-between" pt="sm" px="lg">
                                <ThemedText variant="b4r" color="text-primary">
                                    Interest accrued not due
                                </ThemedText>
                                <ThemedText
                                    variant="b4r" 
                                    color={interestAccruedNotDue < 0 ? "text-emphasis-secondary" : "text-primary"}
                                >
                               {interestAccruedNotDue<0 && '-'}₹{formatIndianCurrency(Math.abs(interestAccruedNotDue) || 0)}
                                </ThemedText>
                            </ThemedView>
                        )}
                        <ThemedView flexDirection="row" justifyContent="space-between" pt="sm" px="lg">
                            <ThemedText variant="b4r" color="text-primary">
                                Advance interest
                            </ThemedText>
                            <ThemedText
                                variant="b4r"
                                color="text-emphasis-secondary"
                            >
                               {advanceInterest<0 && '-'}₹{formatIndianCurrency(Math.abs(advanceInterest) || 0)}
                            </ThemedText>
                        </ThemedView>
                    </ThemedView>
                </AccordionListItem>
                <ThemedView flexDirection='row' justifyContent='space-between' alignItems='center' px="lg" my="lg">
                    <ThemedView flexDirection='row' alignItems='center'>
                        <ThemedText variant='b4s' color='text-primary' >Outstanding amount</ThemedText>
                    </ThemedView>
                    <ThemedText variant='b4s' color={outstandingPrincipal < 0 ? "text-emphasis-secondary" : "text-primary"} >
                        {outstandingPrincipal<0 && '-'}₹{formatIndianCurrency(Math.abs(outstandingPrincipal) || 0)}
                    </ThemedText>
                </ThemedView>
                {lenderId?.toLowerCase() === LENDER_ID.DSP && checkRoundindAmount(selectedAmount) > 0 && 
                    <ThemedView flexDirection="row" justifyContent="space-between" px="lg" mt="md">
                        <ThemedText variant="b4s" color="text-primary">
                            Rounding amount
                        </ThemedText>
                        <ThemedText variant="b4s" color="text-primary">
                            ₹{formatIndianCurrency(checkRoundindAmount(selectedAmount))}
                        </ThemedText>
                    </ThemedView>
                }
                </ThemedView>
            </ThemedView>
            </>
        )
}
export default ForeClosureData